/**
 * Custom Skull icon - Lucide nie ma tego w zainstalowanej wersji. Użyty na
 * karcie zamówienia jako przycisk "dodaj klienta do czarnej listy" (N2,
 * 2026-04-22). Stroke-based, pasuje wizualnie do pozostałych ikon Lucide
 * (stroke 2, width 24).
 */
import type { SVGProps } from 'react';

export function SkullIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      <circle cx="9" cy="12" r="1" />
      <circle cx="15" cy="12" r="1" />
      <path d="M8 20v2h8v-2" />
      <path d="m12.5 17-.5-1-.5 1h1z" />
      <path d="M16 20a2 2 0 0 0 1.56-3.25 8 8 0 1 0-11.12 0A2 2 0 0 0 8 20" />
    </svg>
  );
}
